import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  highlightReportsLoading: false,
  highlightReportsListOptions: {
    sort: {
      date: 'desc',
    },
    limit: 20,
    page: 1,
    search: '',
  },
  highlightReports: [],
  highlightReportsStats: {},
};

export default {
  state,
  getters,
  mutations,
  actions,
};
